export const monetaryValues = {
  positive: "#364a63",
  negative: "#DD453D",
  neutral: "lightGray",
};
